import React, { useContext, useEffect, useState } from "react";
import {
  DropdownOption,
  Dropdown,
  Button
} from "@abb/abb-common-ux-react";
import { getEmCoreTimestamps } from "../../util";
import { RootContext } from "../../contexts/root-context";
import filterConfig from "./filters-config.json";
import { useNavigate } from "react-router-dom";
import "./filters.css";

function MicrogridFilterBar() {
  const {
    setstartTS,
    setendTS,
    isInputSettingClicked,
    setisInputSettingClicked,
    ratingenTimePeriod,
    setRatingenTimePeriod
  } = useContext(RootContext);
  const navigate = useNavigate();
  const [monochrome, setMonochrome] = useState(false);

  useEffect(() => { }, [isInputSettingClicked]);

  const getFilterTime = (filterVal) => {
    setRatingenTimePeriod(String(filterVal[0].label));
    setstartTS(getEmCoreTimestamps(filterVal[0].value).startDate);
    setendTS(getEmCoreTimestamps(filterVal[0].value).endDate);

    // Refresh the page after a short delay to allow state updates
    // setTimeout(() => {
    //   window.location.reload();
    // }, 100);
  };

  const redirectToInputSetting = () => {
    setisInputSettingClicked(true);
    navigate("input-settings");
  };

  return (
    <div className="filter-row row">
      <div className="col-5 col-m-12 col-s-12">
        <div className="filter-header-opt">
          {filterConfig.headerTitle}
          <div style={{ color: '#00000099', fontSize: '11px', marginTop: '4px', marginLeft: '4px' }}>
            Last refresh on : {new Date().toLocaleString()}
          </div>
        </div>
      </div>
      <div className="col-7 col-m-12 col-s-12">
        <div className="filters-group row filterflexes">

          <Dropdown
            id="time-period-emcore"
            className="filter-dropdown col-s-12"
            label="Time Period"
            placeholder={ratingenTimePeriod ? ratingenTimePeriod : "Select Option"}
            monochrome={monochrome}
            value={ratingenTimePeriod}
            onChange={getFilterTime}
          >
            {filterConfig.filterOptions.map((option) => (
              <DropdownOption
                key={option.title}
                label={option.title}
                value={option.value}
              />
            ))}
          </Dropdown>
        </div>
      </div>
    </div>
  );
}

export default MicrogridFilterBar;
